import { cn } from "@/utils";
import React from "react";

type Props = {
  className?: string;
};

const SkeletonChatDetail: React.FC<Props> = ({ className }) => {
  return (
    <div className={cn("p-4 flex gap-4 ml-12 lg:ml-0", className)}>
      <div className="size-[140px] 2xl:size-[180px] bg-light_grey rounded-lg shadow animate-pulse"></div>

      <div className="flex-1 flex flex-col gap-4 animate-pulse">
        <div className="h-4 bg-light_grey rounded w-full" />

        <div className="flex items-center gap-4">
          <div className="h-10 w-20 bg-light_grey rounded-full" />
          <div className="h-10 w-20 bg-light_grey rounded-full" />
        </div>
        <div className="h-4 bg-light_grey rounded w-5/6" />
        <div className="h-4 w-3/4 bg-light_grey rounded" />
      </div>
    </div>
  );
};

const SkeletonChatList: React.FC<Props> = ({ className }) => {
  const roomItem = (
    <div className="flex-1 flex flex-col gap-2 animate-pulse px-4">
      <div className="h-4 bg-light_grey rounded w-2/4" />
      <div className="h-4 bg-light_grey rounded w-5/6" />
      <div className="h-4 w-3/4 bg-light_grey rounded" />
    </div>
  );

  return (
    <div className={cn("flex flex-col gap-8", className)}>
      {roomItem}
      {roomItem}
      {roomItem}
      {roomItem}
      {roomItem}
      {roomItem}
    </div>
  );
};

const SkeletonMemberList = ({
  className,
  type,
}: Props & { type: "account" | "item" }) => {
  const memberItem = (
    <div className="flex items-center gap-2 animate-pulse">
      <div
        className={cn(
          "bg-light_grey",
          type === "account" ? "rounded-full size-10" : "rounded size-8"
        )}
      />
      <div className="flex-1 space-y-1">
        <div className="h-3 bg-light_grey rounded" />
        <div className="h-2 bg-light_grey rounded w-1/6" />
      </div>
    </div>
  );
  return (
    <div className={cn("px-4 flex flex-col gap-4", className)}>
      {memberItem}
      {memberItem}
      {memberItem}
    </div>
  );
};

export { SkeletonChatDetail, SkeletonChatList, SkeletonMemberList };
